/**
 * @generated SignedSource<<fbd43c099929d1939c8e2128492206d3>>
 * @relayHash 41cd8d72cd786835b67fae78de599312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery$variables = {
  issueId: string;
};
export type tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery$data = {
  readonly devOps: {
    readonly entitiesByAssociations: {
      readonly featureFlagEntities: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly id: string;
            readonly summary: {
              readonly enabled: boolean;
            };
          } | null | undefined;
        } | null | undefined>;
        readonly totalCount: number;
      };
    };
  };
};
export type tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery = {
  response: tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery$data;
  variables: tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "ids.0",
        "variableName": "issueId"
      }
    ],
    "kind": "ListValue",
    "name": "ids"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "kind": "ScalarField",
  "name": "enabled"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "DevOps",
          "kind": "LinkedField",
          "name": "devOps",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "DevOpsEntities",
                "kind": "LinkedField",
                "name": "entitiesByAssociations",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "args": (v2/*: any*/),
                      "concreteType": "DevOpsFeatureFlagConnection",
                      "kind": "LinkedField",
                      "name": "featureFlagEntities",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v3/*: any*/),
                          "action": "THROW",
                          "path": "devOps.entitiesByAssociations.featureFlagEntities.totalCount"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "DevOpsFeatureFlagEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "DevOpsFeatureFlag",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": (v4/*: any*/),
                                    "action": "NONE",
                                    "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.id"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v5/*: any*/),
                                    "action": "NONE",
                                    "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.displayName"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": {
                                      "concreteType": "DevOpsFeatureFlagSummary",
                                      "kind": "LinkedField",
                                      "name": "summary",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "RequiredField",
                                          "field": (v6/*: any*/),
                                          "action": "NONE",
                                          "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary.enabled"
                                        }
                                      ]
                                    },
                                    "action": "NONE",
                                    "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary"
                                  }
                                ]
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "devOps.entitiesByAssociations.featureFlagEntities.edges"
                        }
                      ],
                      "storageKey": "featureFlagEntities(first:3)"
                    },
                    "action": "THROW",
                    "path": "devOps.entitiesByAssociations.featureFlagEntities"
                  }
                ]
              },
              "action": "THROW",
              "path": "devOps.entitiesByAssociations"
            }
          ]
        },
        "action": "THROW",
        "path": "devOps"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "DevOpsEntities",
            "kind": "LinkedField",
            "name": "entitiesByAssociations",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "DevOpsFeatureFlagConnection",
                "kind": "LinkedField",
                "name": "featureFlagEntities",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "concreteType": "DevOpsFeatureFlagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "DevOpsFeatureFlag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "concreteType": "DevOpsFeatureFlagSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "featureFlagEntities(first:3)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc",
    "metadata": {},
    "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c17feb1731a74b476c57976ce322ce68";

export default node;
